import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { map } from 'lodash'

import RadioButton from '../RadioButton.js'
import styles from './RadioSelections.module.scss'

const RadioSelections = ({ className, title, options, selectedOption, onSetOption }) => {
  const classNames = cn(styles.radioSelections, className)

  const selections = map(options, (option)=> {
    const style = {}
    let checked = false

    if (selectedOption.name === option.name) {
      checked = true
      style.opacity = '1'
    }

    return (
      <div className={styles.selectionOption} key={option.uuid} style={style}>
        <RadioButton
          checked={checked}
          id={option.uuid}
          name={option.uuid}
          value={option.uuid}
          onChange={() => onSetOption(option)}
          label={option.name}
        />
      </div>
    )
  })

  return (
    <div className={classNames}>
      <div className={styles.selectionTitle}>{title}</div>
      <div className={styles.selectionOptions}>
        {selections}
      </div>
    </div>
  )
}

RadioSelections.defaultProps = {
  title: '',
  options: [],
  selectedOption: {},
  onSetOption: () => {},
}

RadioSelections.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  selectedOption: PropTypes.object,
  onSetOption: PropTypes.func,
}

export default RadioSelections
